module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-fr-FR.3878bdb8.jpg";